import { render, staticRenderFns } from "./collab.vue?vue&type=template&id=7ccfc7a0&"
import script from "./collab.vue?vue&type=script&lang=js&"
export * from "./collab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/collab.vue
// module id = 1635
// module chunks = 0